module.exports = __webpack_public_path__ + "img/home.7a4e01a0.svg";